import { render, staticRenderFns } from "./CargarFormato.vue?vue&type=template&id=2564f61e"
import script from "./CargarFormato.vue?vue&type=script&lang=js"
export * from "./CargarFormato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports